import { render, staticRenderFns } from "./registerSuccess.vue?vue&type=template&id=6528ca59&scoped=true&"
import script from "./registerSuccess.vue?vue&type=script&lang=js&"
export * from "./registerSuccess.vue?vue&type=script&lang=js&"
import style0 from "./registerSuccess.vue?vue&type=style&index=0&id=6528ca59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6528ca59",
  null
  
)

export default component.exports